/**
 * Compliance row shapes. The compliance controller returns raw rows, so
 * these are the column names verbatim.
 */

export interface ObligationRow {
  id: string;
  title: string;
  obligation_type: string;
  due_date: string;
  status: string;
  created_at: string;
}

export interface RegulatoryReportRow {
  id: string;
  report_type: string;
  period: string;
  status: string;
  country_code: string | null;
  created_at: string;
}

export interface EInvoiceRow {
  id: string;
  invoice_id: string | null;
  invoice_type: string;
  country_code: string | null;
  status: string;
  created_at: string;
}

export interface AuditFileRow {
  id: string;
  file_type: string;
  period: string;
  status: string;
  object_key: string | null;
  created_at: string;
}

export interface DataSubjectRequestRow {
  id: string;
  request_type: string;
  subject_email: string;
  status: string;
  requested_at: string;
  created_at: string;
}

export interface RetentionPolicyRow {
  id: string;
  entity_type: string;
  retention_days: number;
  action: string;
  is_active: boolean;
  created_at: string;
}

/**
 * Days until a due date, negative when it has passed. Compliance dates are
 * the one place where "3 days late" needs to read differently from
 * "3 days away", so the sign is preserved rather than absolute.
 */
export function daysUntil(isoDate: string): number {
  const due = new Date(isoDate);
  const today = new Date();
  due.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);
  return Math.round((due.getTime() - today.getTime()) / 86_400_000);
}
